import { ACTIVATION_SUPPLIER_RETAILER, ACTIVATION_LOADING } from '../constants/activationTypes';

const initialState = {
  supplier: undefined,
  supplierRetailer: undefined,
  loading: {
    commission: false,
    supplierRetailer: false,
  },
};

const activation = (state = initialState, action) => {
  switch (action.type) {
    case ACTIVATION_SUPPLIER_RETAILER:
      return {
        ...state,
        supplier: action.payload.supplier,
        supplierRetailer: action.payload,
      };

    case ACTIVATION_LOADING:
      return {
        ...state,
        loading: {
          ...state.loading,
          ...action.payload,
        },
      };
    default:
      break;
  }

  return state;
};

export default activation;
